module.exports = __webpack_public_path__ + "static/media/gcas-banner.498c2a24.png";